import { Table } from "react-bootstrap";
import { withTranslation } from "react-i18next";

function AreaChartComponent({data}){
      return (
        <Table responsive>
          <thead>
            <tr>
              <th>Tipo</th>
              <th>0-10</th>
              <th>11-20</th>
              <th>21-30</th>
              <th>31-40</th>
              <th>>40</th>
            </tr>
          </thead>
          <tbody>
            {
              data.map((item,i)=>(
                <tr key={i}>
                  <td>{item.name}</td>
                  <td>{item.range["0-10"]}</td>
                  <td>{item.range["11-20"]}</td>
                  <td>{item.range["21-30"]}</td>
                  <td>{item.range["31-40"]}</td>
                  <td>{item.range["41<"]}</td>
                </tr>
              ))              
            }            
          </tbody>
        </Table>
      )
}

export default withTranslation()(AreaChartComponent)